import { getLink } from '../../../utils/utils';

import author from './author';


const content = {
  esp: (
    `
			<div style="text-align: justify;">

				<p class="mb-3">
					«Nia afero estas prava! Ni venkos!»
				</p>
					
				<p class="mb-3">
					Revoluciaj sloganoj flirtis tra la tuta lando.
				</p>
					
				<p class="mb-3">
					«For la putran regantaron! 
					For la ekspluatadon! 
					Ni ne permesu ekspluati nin, la laborulajn amasojn! 
					Kiu ne laboras, tiu ne manĝas!»
				</p>
				
				
				<p class="bold text-center mb-3 mt-3">* * *</p>
				
				
				<p class="mb-3">
					Kaj la aliro de la sango al la cerbo estis blokita.
				</p>
				
				<p class="mb-3">
					Oferante sin mem la leŭkocitoj, lipidoj, kombinaĵoj de kalcio baris la arteriojn kondukantajn al la cerebro, por ke tiu parazito, 
					kiu konsumis la sangon de laboruloj, tiu altestaranta aĉulo, kiu ĉiam ricevadis specialan nutradon 
					(eĉ estis konstruita aparta vojo, por ke la plej pura oksigeno iru rekte kaj nure al li…).
				</p>
				
				<p class="mb-3">
					Ne, fripono, ne plu vi regos! 
					Nun ĉiuj ni estas egalaj! 
					Aboli la sistemon de malgranda cirklo de sangocirkulado! 
					Rompi la oldaĉan maŝinon subtenantan la privilegiojn de l’ reganta klaso! 
				</p>
				
				
				<p class="bold text-center mb-3 mt-3">* * *</p>
				
				
				<p class="mb-3">
					La morto de la organismo okazis, laŭnorme, dum kvin minutoj post la pereo de la cerbo. 
				</p>
				
			</div>
    `
  )
}

const itemName = {
  esp: 'Por demokratio'
}

const itemDate = {
	esp: '17 decembro 1987'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
		itemDate: itemDate.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
  }
}

export default item; 